var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"offer-reporter-button",on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('WEBAPP_REPORT_BADOFFERS')))])}
var staticRenderFns = []

export { render, staticRenderFns }